import { get } from '../../shared/api';
import { DefaultResponseDTO } from '../../shared/constants';
import { DashboardRankingsDto } from './dahboards.dto';

export const getDashboardDataRequest = (schoolId: number): Promise<DefaultResponseDTO<DashboardRankingsDto>> => {
  return get<DefaultResponseDTO<DashboardRankingsDto>>(`/schools/${schoolId}/dashboard`);
};
